import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import { encryptTransform } from 'redux-persist-transform-encrypt';

const persistConfig = {
	key: 'mci-f',
	storage,
	transforms: [
		encryptTransform({
			secretKey: 'rT2FZ5y9f9',
			onError: (error) => {
				// eslint-disable-next-line no-console
				console.log(error);
			},
		}),
	],
	whitelist: ['auth'],
};
export { persistConfig };
